import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import { MetricType } from '@/constants/metric-type.enum';
import WaterPressureIcon from '@/comp/common/icons/WaterPressureIcon';
import UnitsEnum from '@/constants/unitsEnum';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { WaterPressureSensorNodeModel } from './WaterPressureSensorNodeModel';
import SensorNodeWidget from '../../components/SensorNodeWidget/SensorNodeWidget';

export class WaterPressureSensorNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.WaterPressureSensor);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new WaterPressureSensorNodeModel();
  }

  nodeUI(event) {
    return (
      <SensorNodeWidget
        engine={this.engine}
        node={event.model}
        width={50}
        height={44}
        data={[
          {
            metric: MetricType.WaterPressureDelta,
            unit: UnitsEnum.bar,
            Icon: <WaterPressureIcon />,
          },
        ]}
      />
    );
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
